import type { ShapBeeswarmFeature } from "./performanceDriversModelFit";
import { isPerformanceChannel } from "./performanceDriversModelFit";

export type PerformanceDriversBeeswarmKind = "static" | "dynamics" | "maneuver";

const MANEUVER_KINDS = new Set<PerformanceDriversBeeswarmKind>(["maneuver"]);

export function isPerformanceDriversManeuverKind(
  kind: PerformanceDriversBeeswarmKind
): boolean {
  return MANEUVER_KINDS.has(kind);
}

/** Hide TWS/TWA/BSP performance channels when "Highlight settings" is checked (straight-line only). */
export function filterPerformanceDriversFeatures(
  features: ShapBeeswarmFeature[],
  hideDominantDrivers: boolean,
  kind: PerformanceDriversBeeswarmKind
): ShapBeeswarmFeature[] {
  if (!hideDominantDrivers || kind !== "static") {
    return features;
  }
  return features.filter(
    (feat) => !isPerformanceChannel(feat.name, feat.label)
  );
}
